module.exports = __webpack_public_path__ + "img/xinwenbaosong.a4b562e4.png";